// useReportExcelExporter.js

/**
 * Exporta datos a Excel como CSV/TSV, usando los labels (títulos) para la cabecera del archivo.
 * @param {Array} data - Los datos del reporte (array de objetos).
 * @param {string} filename - Nombre del archivo de salida.
 * @param {Array} headerLabels - La lista de títulos (labels) para el encabezado del Excel.
 * @param {Array} headerKeys - La lista de claves (keys) de los datos que coinciden con los labels.
 */
export function useReportExcelExporter(data, filename = 'reporte.csv', headerLabels = null, headerKeys = null) {
    if (!data || data.length === 0) {
        alert("No hay datos para exportar.");
        return;
    }

    // Usar las keys pasadas si existen, sino, tomar las keys del primer objeto (fallback)
    const keys = headerKeys || Object.keys(data[0]);
    // Usar los labels pasados si existen, sino, usar las keys como fallback (sin enumeración)
    const labels = headerLabels || keys;

    // 1. Obtener encabezados finales y añadir la columna de enumeración
    const finalHeaders = ['#', ...labels]; // 🛑 Usamos los LABELS aquí 🛑

    // 2. Construir la cabecera CSV (con los labels)
    let csvContent = finalHeaders.join(',') + '\n';

    // 3. Construir el cuerpo CSV
    data.forEach((row, index) => {

        // Iniciar la fila con el número de registro
        let rowValues = [String(index + 1)];

        // Mapear los valores usando las KEYS (ej. 'full_number')
        const existingValues = keys.map(key => {
            let value = row[key] === null || row[key] === undefined ? '' : String(row[key]);

            // Escapar comillas y envolver en comillas
            if (value.includes(',') || value.includes('\n') || value.includes('"')) {
                value = `"${value.replace(/"/g, '""')}"`;
            }
            return value;
        });

        rowValues = rowValues.concat(existingValues);
        csvContent += rowValues.join(',') + '\n';
    });

    // 4. Crear el Blob y descargar (sin cambios)
    const blob = new Blob(["\ufeff", csvContent], { type: 'text/csv;charset=utf-8;' });
    // ... (resto del código de descarga) ...
    const link = document.createElement("a");

    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } else {
        window.open('data:text/csv;charset=utf-8,' + escape(csvContent));
    }
}